import { createAsyncAction } from "../actionCreators";
import { API, Space, CustomField } from "@thenounproject/lingo-core";

type Args = {
  spaceId: Space["id"];
  field: CustomField;
  confirmDelete?: boolean;
};

const [useDeleteCustomField, deleteCustomField] = createAsyncAction(
  "fields/deleteCustomField",
  async ({ spaceId, field, confirmDelete = false }: Args) => {
    const res = await API.call<{ field: number }>({
      endpoint: `/spaces/${spaceId}/fields/${field.id}`,
      method: "DELETE",
      data: { ...field, confirm_delete: confirmDelete },
    });
    return { ...res, result: res.result.field };
  }
);

export default useDeleteCustomField;
export { deleteCustomField };
